import { render } from "./FiduPage.vue?vue&type=template&id=1dd696be"
import script from "./FiduPage.vue?vue&type=script&lang=js"
export * from "./FiduPage.vue?vue&type=script&lang=js"

import "./FiduPage.vue?vue&type=style&index=0&id=1dd696be&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__